/**
 * tRPC Client Setup
 * Type-safe API client that connects to the tRPC gateway server
 */
import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@server/router';
import { getAuthHeaders } from '@/lib/auth-token';

// Create the tRPC React hooks
export const trpc = createTRPCReact<AppRouter>();

// tRPC server URL — use proxy path so Vite dev proxy forwards to :4301
const TRPC_URL = import.meta.env.VITE_TRPC_URL || '/trpc';

// Create the tRPC client instance
export function createTRPCClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: TRPC_URL,
        headers() {
          return getAuthHeaders();
        },
      }),
    ],
  });
}
